import { css } from '@emotion/react';
import { Inline } from '@spark-web/inline';
import { Text } from '@spark-web/text';
import { useState } from 'react';

export const VendorDescription = ({ description }: { description: string }) => {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const descriptionBlurb = description.substring(0, 160);
  const isDescriptionComplete = description === descriptionBlurb;

  return (
    <Inline gap="medium" css={css({ display: 'block' })}>
      <Text inline size="xsmall">
        {isDescriptionExpanded || isDescriptionComplete ? description : `${descriptionBlurb}...`}&nbsp;
        {!isDescriptionComplete && (
          <Text
            inline
            size="xsmall"
            tone="info"
            css={css({ textDecoration: 'underline', cursor: 'pointer' })}
            onClick={(event) => {
              event.preventDefault();
              setIsDescriptionExpanded(!isDescriptionExpanded);
            }}
            as="button"
            type="button"
          >
            {isDescriptionExpanded ? 'read less' : 'read more'}
          </Text>
        )}
      </Text>
    </Inline>
  );
};
